import { IonLabel, IonText } from '@ionic/react'
import React, { HTMLAttributes } from 'react'
import { getStyleForPHI, IPHIComponent } from '../phi/phi.component'

export interface ILabel extends HTMLAttributes<HTMLIonLabelElement>, IPHIComponent {
  label?: string
  dataTestID?: string
  size?: number
}

const LabelComponent: React.FC<ILabel> = (props: ILabel) => {
  const { label, dataTestID, size, isPHI } = props

  let TextTag

  if (!size) {
    TextTag = <IonText>{label}</IonText>
  } else {
    const headingSize = !size || size < 1 || size > 6 ? 4 : size
    const HTag = `h${headingSize}` as keyof JSX.IntrinsicElements

    TextTag = (
      <IonText>
        <HTag>{label}</HTag>
      </IonText>
    )
  }

  return (
    <div data-private={isPHI} style={getStyleForPHI(isPHI)}>
      <IonLabel data-testid={dataTestID} {...props}>
        {TextTag}
      </IonLabel>
    </div>
  )
}

export default LabelComponent
